<div class="container mt-5">
  <div *ngIf="application; else noApplication">
    <div class="header bg-gradient-primary text-white p-3 rounded-top shadow-sm d-flex justify-content-between align-items-center">
      <h3 class="mb-0">Bewerbungsdetails</h3>
      <span class="badge rounded-pill" [ngClass]="getStatusBadgeClass(application.status)">
        {{ application.status | titlecase }}
      </span>
    </div>
    <div class="border p-4 rounded-bottom shadow-sm">
      <div class="row">
        <!-- Sidebar for User Information -->
        <div class="col-md-4 col-lg-3 mb-4 mb-md-0">
          <div class="text-center">
            <img [src]="application.user.image" 
                 class="img-fluid rounded-circle mb-3 user-avatar" 
                 alt="{{ application.user.fullName }}'s avatar">
            <h6 class="text-primary">Benutzerinformationen</h6>
            <div class="user-details">
              <p><i class="fa-solid fa-user me-2"></i> {{ application.user.fullName }}</p>
              <p><i class="fa-solid fa-envelope me-2"></i> {{ application.user.email }}</p>
              <p><i class="fa-solid fa-phone me-2"></i> {{ application.user.phone || 'Nicht angegeben' }}</p>
            </div>
          </div>
        </div>

        <!-- Main Content for Job and Application Details -->
        <div class="col-md-8 col-lg-9">
          <div class="details-content">
            <h6 class="text-primary mb-3"><i class="fa-solid fa-briefcase me-2"></i>Stelleninformationen</h6>
            <div class="detail-row">
              <div class="detail-label"><i class="fa-solid fa-clipboard-list me-2"></i>Titel:</div>
              <div class="detail-value">{{ application.job.title }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label"><i class="fa-solid fa-tags me-2"></i>Kategorie:</div>
              <div class="detail-value">{{ application.job.category }}</div>
            </div>

            <h6 class="text-primary mt-4 mb-3"><i class="fa-solid fa-file-alt me-2"></i>Bewerbungsdetails</h6>
            <div class="detail-row">
              <div class="detail-label"><i class="fa-solid fa-file-lines me-2"></i>Anschreiben:</div>
              <div class="detail-value">{{ application.coverLetter || 'Nicht angegeben' }}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label"><i class="fa-solid fa-file-pdf me-2"></i>Lebenslauf:</div>
              <div class="detail-value">
                <a [href]="application.cvUrl" target="_blank" class="btn btn-primary btn-sm ms-2">
                  <i class="fa-solid fa-download me-1"></i> Lebenslauf anzeigen
                </a>
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-label"><i class="fa-solid fa-calendar-alt me-2"></i>Bewerbungsdatum:</div>
              <div class="detail-value">{{ application.applicationDate?.toDate() | date:'medium' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end mt-4">
        <a routerLink="/Admin/Applications" class="btn btn-outline-secondary">
          <i class="fa-solid fa-arrow-left me-1"></i> Zurück zu Bewerbungen
        </a>
      </div>
    </div>
  </div>
  <ng-template #noApplication>
    <div style="text-align: center;" *ngIf="showSpinner">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Lädt...</span>
      </div>
    </div>
  
    <div class="alert alert-warning mt-5 p-4 shadow-sm" role="alert" *ngIf="showSpinner==false">
      <i class="fa-solid fa-exclamation-triangle me-2"></i> Keine Bewerbung gefunden.
    </div>
  </ng-template>
</div>